import { produce } from 'immer';
import * as api from '../../lib/api';
import { ScopedAsyncType } from './scoped-type';
import { asyncAction } from './async-action';

const AsyncType = ScopedAsyncType('EARLY_SEASON_FUNGIVIDE');

const LOAD_FUNGICIDE = AsyncType('LOAD_FUNGICIDE');

const SLICE = 'earlySeasonFungicide';

export const selectors = {
  isLoading: (state) => state[SLICE].isLoading,
  fields: (state) => state[SLICE].fields,
  error: (state) => state[SLICE].error,
};

export const actions = {
  loadEarlySeasonFungicide,
};

const reducerHandlers = {
  [LOAD_FUNGICIDE.start]: reduceLoadFungicideStart,
  [LOAD_FUNGICIDE.complete]: reduceLoadFungicideComplete,
  [LOAD_FUNGICIDE.failure]: reduceLoadFungicideFailure,
};

export const reducers = {
  [SLICE]: (state = {}, { type, payload } = {}) => {
    if (!reducerHandlers[type]) return state;
    return produce(state, (draft) => reducerHandlers[type](draft, payload));
  },
};

function loadEarlySeasonFungicide(growerId) {
  return asyncAction(LOAD_FUNGICIDE, () => api.getFungicideFields(growerId));
}

function reduceLoadFungicideStart(state) {
  state.isLoading = true;
  state.error = null;
  state.fields = [];
}

function reduceLoadFungicideComplete(state, payload) {
  state.isLoading = false;
  state.error = null;
  state.fields = payload;
}

function reduceLoadFungicideFailure(state, payload) {
  state.isLoading = false;
  state.error = payload;
  state.fields = [];
}
